import "./Divider.scss";

const Divider = ({ text = "or" }) => {
  return (
    <div className="divider-flex">
      <span className="divider-flex__text">{text}</span>
    </div>
  );
};

export default Divider;
